import React, { useState, useRef } from "react";
import axios from "axios";
import PersonImg from "../../../../assets/images/VidoUpload/unsplash_ChylazdaLkU.png";
import recordLive from "../../../../assets/images/recordLive.png";
import "./VidoUpload.css";
import { useEffect } from "react";
import { Markup } from "interweave";
import restartImg from "../../../../assets/images/restart.png";
import pauseImg from "../../../../assets/images/pause.png";
import recordImg from "../../../../assets/images/record.png";
import noImage from "../../../../assets/images/settings/no-image.png";
import swal from "sweetalert";
import useTimer from "./Timer/useTimer";
import { formatTime } from "./Timer/helper";
import styles from "./style.module.css";
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { FileDrop } from "react-file-drop";
import { Link, useHistory } from "react-router-dom";
import ReactPlayer from "react-player";

import {
  useRecordWebcam,
  CAMERA_STATUS
} from "react-record-webcam";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import useVdieoHandleS3 from "../../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../../Screen/MediaUploadProgressBar";
import useVideoHandleWithCompress from "../../../../CustomHooks/useVideoHandleWithCompress";


const VidoUpload = (props) => {
  const { imageCdnUrl , videoCdnUrl } = useContext(serverInfo);

  const history = useHistory();
  const {
    timer,
    handleStart,
    handlePause,
    handleReset
  } = useTimer(0);
  const [isRecording, setIsRecording] = useState(false);
  const [greeting, setGreeting] = useState({});
  const [greetingRegistration, setGreetingRegistration] = useState({});
  const [loading, setloading] = useState(true);
  const [errorList, setErrorList] = useState({});
  const [pageNum, setPageNum] = useState(1);
  const [isVideoReady, setIsVideoReady] = useState(true);



  const [selectFile, setSelectFile] = useState(null);

  const fileInputRef = useRef(null);
  // Video File Handle
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'greetings/videos', videoDelKey);

  console.log("Uploaded Video ", videoUrl, videoKey, videoProgress, videoHeight,videoWidth);

  const onFileInputChange = async (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
    setIsVideoReady(false);
  };

  const loadedVideo = (s) => {
    setIsVideoReady(true);
  };

  const onTargetClick = () => {

    fileInputRef.current.click();
  };

  const handleVideoUpload = () => {

    if (videoUrl === null) {
      swal("Opps...", "Please upload a file first", "warning")
    } else {
      const formData = new FormData()
      formData.append('video', videoKey);
      formData.append('greeting_registration_id', greetingRegistration?.id);

      axios.post(`/api/star/greeting_video_upload`, formData).then(res => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push('/superstar/greetings-registered-list');
        } else if (res.data.status === 422) {
          setErrorList(res.data.validation_errors);
        } else {
          // swal("Error", res.data.message, "error");
        }
      });
    }
  };

console.log('videovideovideovideo==',video);


  useEffect(() => {
    const userIndex = props.match.params.greeting_registration_id;

    getInitialData(userIndex);
  }, [props.match.params.greeting_registration_id]);

  const OPTIONS = {
    filename: greetingRegistration?.user?.first_name + "-" + greetingRegistration?.user?.last_name,
    fileType: "mp4",
    width: 1920,
    height: 1080
  };
  const recordWebcam = useRecordWebcam(OPTIONS);
  const getInitialData = (userIndex) => {
    axios.get(`/api/star/single_greeting_registration/${userIndex}`).then((res) => {
      if (res.status === 200) {
        setGreeting(res.data.greeting);
        setGreetingRegistration(res.data.greetingsRegistration);
        recordWebcam.open()
        setloading(false);
      }
    });
  };
  const handleDownloadBtn = () => {
    if (recordWebcam.status !== CAMERA_STATUS.PREVIEW) {
      swal("Opps...", "Please record a video !", "warning");
    } else {
      setIsRecording(false);
      recordWebcam.download();
    }
  };
  const handleRecordingBtn = () => {
    if (isRecording) {
      recordWebcam.stop()
      handlePause();
    } else {
      recordWebcam.start()
      handleReset();
      handleStart()
    }
    setIsRecording(!isRecording);
  };

  return (

    <>{loading === true ?
      <>
        <h5 className="text-white justify-content-center text-center mx-auto">Loading...</h5>
      </> :
      <>
        <div>
          <div className="container-fluid mt-5 mb-3">
            <div className="row">
              <div className="col-md-7">
                {
                  pageNum === 1 ?
                    <>
                      <div className="card video-style" style={{ borderTop: '3px solid #FFC107' }}>
                        <div className="text-center vido_img p-2" style={{ backgroundColor: '#1a1a1a', borderRadius: '8px' }}>
                          <video
                            ref={recordWebcam.webcamRef}
                            style={{
                              width: '100%',
                              display: `${
                                recordWebcam.status === CAMERA_STATUS.OPEN ||
                                recordWebcam.status === CAMERA_STATUS.RECORDING
                                  ? "block"
                                  : "none"
                              }`,
                              borderRadius: '8px'
                            }}
                            autoPlay
                            muted
                          />
                          <video
                            ref={recordWebcam.previewRef}
                            style={{
                              width: '100%',
                              display: `${
                                recordWebcam.status === CAMERA_STATUS.PREVIEW ? "block" : "none"
                              }`,
                              borderRadius: '8px'
                            }}
                            controls
                          />
                          <div>
                            <div className="row">
                              <div className="col-md-3">
                                <div className="d-flex m-3 align-items-center">
                                  <div>
                                    <img src={recordLive} alt="Recording" />
                                  </div>
                                  <div className="ms-2">
                                    <p className="text-warning fw-bold" style={{ fontSize: '16px' }}>{formatTime(timer)}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="container text-center mt-4">
                        <button onClick={() => setPageNum(2)} className="btn btn-warning fw-bold py-2 px-5" style={{ fontSize: '16px', borderRadius: '6px' }}>
                          <i className="fas fa-arrow-right me-2"></i>Upload Video
                        </button>
                      </div>
                    </>
                 : <></>
                }
                {
                  pageNum === 2 ?
                    <div>
                      <div className={styles.CardBorder} style={{ borderTop: '3px solid #FFC107' }}>
                        <div className={styles.fileUploadCard} style={{ backgroundColor: '#121212', borderRadius: '8px', padding: '24px' }}>
                          <input
                            onChange={(e) =>
                              onFileInputChange(e.target.files)
                            }
                            ref={fileInputRef}
                            type="file"
                            accept="video/mp4"
                            className={styles.hidden}
                          />
                          {/* Header */}
                          <div className="mb-4 pb-3 border-bottom border-warning">
                            <h5 className="text-warning fw-bold mb-0">
                              <i className="fas fa-film me-2"></i>Upload Greeting Video
                            </h5>
                          </div>
                          
                          <div className={styles.text}>
                            <button onClick={onTargetClick} className={styles.uploadBtn} style={{ backgroundColor: '#FFC107', borderRadius: '8px', padding: '10px 20px', color: '#000', fontWeight: 'bold', border: 'none' }}>
                              <i className="fas fa-cloud-upload-alt me-2"></i>Choose File
                            </button>
                            <p className="text-center text-light mt-3">
                              {selectFile !== null ? (
                                <>
                                  <span className="text-success fw-bold"><i className="fas fa-check-circle me-1"></i>{selectFile.name}</span>
                                  <span className={styles.x} onClick={() => setSelectFile(null)} style={{ cursor: 'pointer', marginLeft: '10px' }}>
                                    <AiOutlineCloseCircle className="icon text-danger" style={{ fontSize: '20px' }} />
                                  </span>
                                </>
                              ) : (
                                <span className="text-muted"><i className="fas fa-file-video me-1"></i>No file chosen</span>
                              )}
                            </p>
                            {errorList.video && <span className="text-danger fw-bold"><i className="fas fa-exclamation-circle me-1"></i>{errorList.video}</span>}
                          </div>
                          
                          {/* Video Preview */}
                          <div className="mt-4">
                            {videoUrl ? (
                              <div style={{ borderRadius: '8px', overflow: 'hidden', border: '2px solid #FFC107' }}>
                                <ReactPlayer
                                  onReady={(e) => loadedVideo(e)}
                                  url={videoUrl}
                                  controls
                                  playing={false}
                                  volume={1}
                                  width="100%"
                                  height="35vh"
                                />
                              </div>
                            ) : !isVideoReady ? (
                              <div
                                className="d-flex flex-column justify-content-center align-items-center"
                                style={{ width: "100%", height: "35vh", backgroundColor: "#1a1a1a", borderRadius: "8px", border: '2px solid #FFC107' }}
                              >
                                <div className="spinner-border" style={{ color: "#FFC107" }} role="status" />
                                <div className="mt-3 text-warning text-center fw-bold">
                                  <i className="fas fa-cog fa-spin me-2"></i>Compressing video...
                                </div>
                              </div>
                            ) : (
                              <FileDrop
                                onDrop={(e) =>
                                  onFileInputChange(e.target.files)
                                }
                                onTargetClick={onTargetClick}
                                targetClassName={styles.target}
                                className={styles.filedrop}
                                draggingOverFrameClassName={styles.filedropDrag}
                              >
                                <div className="p-5 text-center" style={{ borderRadius: '8px', border: '2px dashed #FFC107', backgroundColor: 'rgba(255, 193, 7, 0.05)' }}>
                                  <i className="fas fa-cloud-upload-alt" style={{ fontSize: '48px', color: '#FFC107', marginBottom: '10px', display: 'block' }}></i>
                                  <p className="text-light fw-bold">Click or Drag & Drop Video</p>
                                  <small className="text-light">MP4 format recommended</small>
                                </div>
                              </FileDrop>
                            )}

                            {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                          </div>
                        </div>
                      </div>
                      <div className="container text-center mt-4">
                        <button onClick={() => handleVideoUpload()} className="btn btn-warning fw-bold py-2 px-5" style={{ fontSize: '16px', borderRadius: '6px' }}>
                          <i className="fas fa-upload me-2"></i>Submit Video
                        </button>
                      </div>
                    </div>
                 : <></>
                }

              </div>
              <div className="col-md-5">
                <div className="card right-video-card" style={{ borderTop: '3px solid #17a2b8' }}>
                  <div className="card-body p-4">
                    {/* User Profile Section */}
                    <div className="text-center mb-4 pb-3 border-bottom border-info">
                      <div className="position-relative d-inline-block mb-3">
                        <div style={{
                          width: '120px',
                          height: '120px',
                          borderRadius: '50%',
                          border: '3px solid #17a2b8',
                          padding: '3px',
                          backgroundColor: '#1a1a1a',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          overflow: 'hidden'
                        }}>
                          <img
                            className="img-fluid"
                            src={greetingRegistration?.user?.image != null ? imageCdnUrl + greetingRegistration?.user?.image : noImage}
                            alt="Profile Icon"
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%',
                              borderRadius: '50%'
                            }}
                          />
                        </div>
                        <span className="badge bg-info text-dark position-absolute bottom-0 end-0" style={{ fontSize: '12px', padding: '6px 10px' }}>
                          <i className="fas fa-user me-1"></i>Requester
                        </span>
                      </div>
                      <h5 className="text-white fw-bold mt-3 mb-1">
                        {greetingRegistration?.user?.first_name} {greetingRegistration?.user?.last_name}
                      </h5>
                      <p className="text-light small mb-0">
                        <i className="fas fa-phone me-1"></i>{greetingRegistration?.user?.phone}
                      </p>
                    </div>

                    {/* Purpose Badge */}
                    <div className="mb-4">
                      <label className="text-warning small fw-bold d-block mb-2">
                        <i className="fas fa-tag me-1"></i>Greeting Type
                      </label>
                      <span className="badge bg-warning text-dark px-4 py-2" style={{ fontSize: '14px' }}>
                        {greetingRegistration?.purpose ? greetingRegistration.purpose.charAt(0).toUpperCase() + greetingRegistration.purpose.slice(1) : 'N/A'}
                      </span>
                    </div>

                    {/* Recipient Name */}
                    {greetingRegistration.name && (
                      <div className="mb-4 p-3 bg-dark rounded border border-warning">
                        <label className="text-warning small fw-bold d-block mb-2">
                          <i className="fas fa-user-check me-1"></i>For
                        </label>
                        <p className="text-white mb-0 fw-bold" style={{ fontSize: '16px' }}>
                          {greetingRegistration.name}
                        </p>
                      </div>
                    )}

                    {/* Greeting Context */}
                    {greetingRegistration.additional_message && (
                      <div className="mb-4 p-3 bg-dark rounded border border-info">
                        <label className="text-info small fw-bold d-block mb-2">
                          <i className="fas fa-align-left me-1"></i>Greeting Context
                        </label>
                        <p className="text-white mb-0">
                          <Markup content={greetingRegistration.additional_message} />
                        </p>
                      </div>
                    )}

                    {/* Instructions Section */}
                    {greeting?.instruction && (
                      <div className="p-3 bg-dark rounded border border-warning">
                        <label className="text-warning small fw-bold d-block mb-2">
                          <i className="fas fa-info-circle me-1"></i>Instructions
                        </label>
                        <p className="text-light mb-0 small">
                          <Markup content={greeting.instruction} />
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    }
    </>
  );
};

export default VidoUpload;
